// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import styles from './pricing_lobby.module.less';
import {Period_slider} from './period_slider';
import {Better_fit_resi_banner, Contact_banner} from './pricing_section';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import Icon_dedicated_dc from '../../img/icons/24/color/dedicated_dc.svg';
import Icon_shared_dc from '../../img/icons/24/color/shared_dc.svg';
import Icon_isp from '../../img/icons/24/color/isp.svg';
import Icon_isp_plus from '../../img/icons/24/color/isp_premium.svg';
import Icon_smart_resi from '../../img/icons/24/color/residential.svg';
import Icon_tickets from '../../img/icons/24/color/events_resi.svg';
import Icon_sneakers from '../../img/icons/24/color/sneakers.svg';
import Icon_ecommerce from '../../img/icons/24/color/events_and_ecommerce.svg';
import Icon_triangle_down from '../../img/icons/16/triangle_down.svg';
import Icon_check from '../../img/icons/16/check.svg';
import {oculus_proxy_type} from '../../types';
import {Lobby_cards} from './lobby_cards';
import {HP_faq} from '../homepage/faq';

const proxy_icons = {
    [Proxy_type.SHARED_ISP]: <Icon_isp/>,
    [Proxy_type.ISPPREM]: <Icon_isp_plus/>,
    [Proxy_type.EV_ISP]: <Icon_ecommerce/>,
    [Proxy_type.SDC]: <Icon_shared_dc/>,
    [Proxy_type.DDC]: <Icon_dedicated_dc/>,
    [Proxy_type.RES]: <Icon_smart_resi/>,
    [Proxy_type.SNK]: <Icon_sneakers/>,
    [Proxy_type.EV_RES]: <Icon_tickets/>,
};

export const proxy_titles = {
    [Proxy_type.SHARED_ISP]: 'ISP',
    [Proxy_type.ISPPREM]: 'ISP Premium',
    [Proxy_type.EV_ISP]: 'Events & E-commerce',
    [Proxy_type.SDC]: 'Shared Datacenter',
    [Proxy_type.DDC]: 'Dedicated Datacenter',
    [Proxy_type.RES]: 'Rotating Residential',
    [Proxy_type.SNK]: 'Sneakers Residential',
    [Proxy_type.EV_RES]: 'Events Tickets Residential',
};

interface i_menu_props {
    selected_type: Proxy_type;
    on_type_change: (type: Proxy_type)=>void;
}

export const Menu = (props: i_menu_props)=>{
    const {theme} = useContext(Settings_context);
    const {selected_type, on_type_change} = props;
    return <div className={styles.menu}>
      <div className={styles.menu_group}>
        <p className={cn(theme.p14, theme.reg)}>ISP Proxies</p>
        <Menu_item title='ISP' type={Proxy_type.SHARED_ISP}
          selected={selected_type==Proxy_type.SHARED_ISP}
          on_click={on_type_change}/>
        <Menu_item title='ISP Premium' type={Proxy_type.ISPPREM}
          selected={selected_type==Proxy_type.ISPPREM}
          on_click={on_type_change}/>
        <Menu_item title='Events & E-commerce' type={Proxy_type.EV_ISP}
          selected={selected_type==Proxy_type.EV_ISP}
          on_click={on_type_change}/>
      </div>
      <div className={styles.menu_group}>
        <p className={cn(theme.p14, theme.reg)}>Datacenter Proxies</p>
        <Menu_item title='Shared Datacenter' type={Proxy_type.SDC}
          selected={selected_type==Proxy_type.SDC} on_click={on_type_change}/>
        <Menu_item title='Dedicated Datacenter' type={Proxy_type.DDC}
          selected={selected_type==Proxy_type.DDC} on_click={on_type_change}/>
      </div>
      <div className={styles.menu_group}>
        <p className={cn(theme.p14, theme.reg)}>Residential Proxies</p>
        <Menu_item title='Rotating Residential' type={Proxy_type.RES}
          selected={selected_type==Proxy_type.RES} on_click={on_type_change}/>
        <Menu_item title='Sneakers Residential' type={Proxy_type.SNK}
          selected={selected_type==Proxy_type.SNK} on_click={on_type_change}/>
        <Menu_item title='Events Tickets Residential' type={Proxy_type.EV_RES}
          selected={selected_type==Proxy_type.EV_RES}
          on_click={on_type_change}/>
      </div>
  </div>;
};

interface i_menu_item_props {
    title: string;
    type: oculus_proxy_type;
    selected: boolean;
    on_click: (type: Proxy_type)=>void;
}

const Menu_item = (props: i_menu_item_props)=>{
    const {theme} = useContext(Settings_context);
    const {title, type, selected, on_click} = props;
    return <div className={cn(styles.menu_item, selected && styles.selected)}
    onClick={()=>on_click(type)}>
      <div className={styles.menu_item_content}>
        <div className={styles.icon_container}>
          {proxy_icons[type]}
        </div>
        <p className={cn(theme.p14, theme.med, theme.color_n700)}>
          {title}</p>
      </div>
    </div>;
};

interface i_product_dropdown_props {
    selected_type: Proxy_type;
    on_type_change: (type: Proxy_type)=>void;
    cls?: string;
}

export const Product_dropdown = (props: i_product_dropdown_props)=>{
    const {theme} = useContext(Settings_context);
    const {selected_type, on_type_change, cls} = props;
    const [is_open, set_is_open] = useState(false);
    const toggle_dropdown = ()=>set_is_open(!is_open);
    return <div className={cn(styles.product_dropdown, cls,
      is_open && styles.open)}>
      <div className={styles.dropdown_trigger} onClick={toggle_dropdown}>
        <p className={cn(theme.p14, theme.med, theme.color_n700)}>
          {proxy_titles[selected_type]}
        </p>
        <div className={styles.icon_container}>
          <Icon_triangle_down className={styles.triangle_icon}/>
        </div>
      </div>
      {is_open &&
        <div className={styles.dropdown_content}>
          {Object.keys(proxy_titles).map(type=>
            <div
              key={type}
              className={cn(styles.dropdown_item,
                selected_type==type && styles.selected)}
              onClick={()=>{
                on_type_change(type as Proxy_type);
                set_is_open(false);
              }}
            >
              <p className={cn(theme.p14,
                selected_type==type ? theme.bold : theme.med,
                selected_type==type ? theme.color_n700 : theme.color_n600)}>
                {proxy_titles[type as Proxy_type]}
              </p>
              {selected_type==type &&
                <div className={styles.icon_container}>
                  <Icon_check/>
                </div>
              }
            </div>
          )}
        </div>}
    </div>;
};

export const Pricing_lobby = ()=>{
    const {theme} = useContext(Settings_context);
    const [selected_type, set_selected_type] =
        useState<Proxy_type>(Proxy_type.SDC);
    const handle_type_change = (type: Proxy_type)=>{
        set_selected_type(type);
    };
    return <div className={cn(theme.container, styles.container)}>
      <div className={styles.root}>
        <div className={styles.header}>
          <h3>Pricing</h3>
          <Period_slider is_lobby_page={true}/>
        </div>
        <Product_dropdown
          selected_type={selected_type}
          on_type_change={handle_type_change}
        />
        <div className={styles.mid_layout}>
          <h3>Pricing</h3>
          <div className={styles.mid_controls}>
            <Product_dropdown
              selected_type={selected_type}
              on_type_change={handle_type_change}
              cls={styles.mid_dropdown}
            />
            <Period_slider is_lobby_page={true}/>
          </div>
        </div>
        <div className={styles.content}>
          <Menu selected_type={selected_type}
            on_type_change={handle_type_change}/>
          <Lobby_cards selected_type={selected_type}/>
        </div>
        {selected_type == 'smart_resi' &&
          <Better_fit_resi_banner on_click={handle_type_change}/>}
        <Contact_banner is_lobby_page={true}/>
        <HP_faq/>
      </div>
    </div>;
};
